import {
  FlueId,
  MunicipalityId,
  parseStreetAddressExprOrUndef,
  PostalCodeId,
} from "firefly-shared-ts-domain";
import { GuidUtils, StringUtils } from "shared-ts-utils-core";
import {
  andExpr,
  containsExpr,
  equalsExpr,
  Expr,
  fieldExpr,
  Query,
  SortItemDto,
  valExpr,
} from "shared-ts-utils-query";

export type FlueStatusQueryInput = {
  municipality?: MunicipalityId | null;
  postalCode?: PostalCodeId | null;
  problematicFlue?: boolean | null;
  id?: FlueId | null;
  search?: string | null;
  sort?: Array<SortItemDto> | null;
};

export class FlueStatusQuery extends Query {
  constructor(args: FlueStatusQueryInput) {
    super({ sort: args.sort, where: FlueStatusQuery.resolveWhere(args) });
  }

  static resolveWhere(args: FlueStatusQueryInput): Expr | undefined {
    let where: Expr | undefined = undefined;
    if (StringUtils.isNotBlank(args.id)) {
      where = containsExpr(fieldExpr("id"), valExpr(args.id));
    }
    if (StringUtils.isNotBlank(args.municipality)) {
      const expr = equalsExpr(
        fieldExpr("municipalityId"),
        valExpr(args.municipality)
      );
      where = where != null ? andExpr(where, expr) : expr;
    }
    if (StringUtils.isNotBlank(args.postalCode)) {
      const expr = equalsExpr(
        fieldExpr("postalAddress.code"),
        valExpr(args.postalCode)
      );
      where = where != null ? andExpr(where, expr) : expr;
    }

    if (args.problematicFlue != null && args.problematicFlue) {
      const expr = equalsExpr(
        fieldExpr("flue.problematic"),
        valExpr(args.problematicFlue)
      );
      where = where != null ? andExpr(where, expr) : expr;
    }

    if (StringUtils.isNotBlank(args.search)) {
      if (args.search != null && GuidUtils.isGuid(args.search)) {
        return equalsExpr(fieldExpr("id"), valExpr(args.search));
      }
      const expr = parseStreetAddressExprOrUndef(args.search);
      if (expr != null) {
        where = where != null ? andExpr(where, expr) : expr;
      }
    }
    return where;
  }
}
